import React, { Dispatch } from 'react';
import { connect } from 'react-redux';
import { IStudentListProps } from '../../models/components/student-list';
import Translator from '../../core/i18n';
import { Common } from '../../core/common';
import { SecureImage } from '../core/secureImage';
import Paginate from './paginate';
import Loading from '../loading/loading';
import ContentLoader from 'react-content-loader';
import { Table } from 'reactstrap';
import SortedColumn from './sorted-column';
import { EQrPollingStatusType, IAttendanceUserData } from '../../models/components/qrPolling';
import { IAction, IAppState } from '../../models/action/core';
import * as Actions from '../../store/actions/qrPolling';
import { Confirm } from '../notification/main';
import moment from 'moment';
import { Log } from 'ng2-logger';
import { IFilters } from '../../models/action/qrPolling';
import { Button } from '../ui-elements/main';


const T = Translator.create();
let _common: Common;
const _lodash = require('lodash');
const _logger = Log.create('attendance_student_list_page');

class StudentList extends React.Component<IStudentListProps, any> {

    public state = {
        selectedUserIds: [],
        filters:{
            orderBy: '',
            query: '',
            page: 1,
            total: -1,
            skip: 0,
            take: 10
        }
    };

    onPageChange = (page: number) => {
        this.props.filters.page = page;
        this.props.onChange(page)
    };

    callbackFunction = () => {
        if(this.props.studentListType === 0 || this.props.studentListType === 1){
            this.getAttendanceStudentList(this.props.filters.page, "", "" );
        }
    }
    addStudenToAttendance = (selectedUser: any) => {
        const { attendanceId, attendanceGuid } = this.props.AttendanceData

        this.setState({ selectedUserIds: [selectedUser.userId] }, () => {
            this.props.dispatch(Actions.AddStudentToAttendance(this.state.selectedUserIds, this.props.coursePageClassId!, attendanceId, attendanceGuid, this.props.studentListType, 'AddStudentToAttendance', 'get', this.callbackFunction));
        })

    }

    removeStudenToAttendance = () => {
        const { attendanceId, attendanceGuid } = this.props.AttendanceData
        this.props.dispatch(Actions.RemoveStudentToAttendance(this.state.selectedUserIds, this.props.coursePageClassId!, attendanceId, attendanceGuid, this.props.studentListType, 'RemoveStudentToAttendance', 'get', this.callbackFunction));
    }

    handleAddAttendanceUser = (selectedUser: any) => {
        this.setState({ selectedUserIds: [selectedUser.userId] }, () => {
            Confirm.setConfirm('twoOption', this.addStudenToAttendance, `${selectedUser.firstName} ${selectedUser.lastName} yoklamaya eklemek istediğinize emin misiniz ?`, null, null, undefined, undefined, undefined, T.t('r_yes'), T.t('r_no'));
        })
    }

    handleRemoveAttendanceUser = (selectedUser: any) => {
        this.setState({ selectedUserIds: [selectedUser.userId] }, () => {
            Confirm.setConfirm('twoOption', this.removeStudenToAttendance, T.t("r_remove_from_attendance_confirmation_message").replace("{0}",selectedUser.firstName).replace("{1}", selectedUser.lastName), null, null, undefined, undefined, undefined, T.t('r_yes'), T.t('r_no'));
        })
    }

    getAttendanceStudentList = (page: number, orderBy: string, spinnerId: string) => {
        const filters: IFilters = {
            Take: 10,
            Page: page,
            OrderBy: orderBy,
            Query: ""
        }
        this.props.dispatch(Actions.GetAttendanceStudentsList(this.props.coursePageClassId ?? "-1", this.props.AttendanceData.attendanceId ?? "0", this.props.AttendanceData.attendanceGuid ?? "0", this.props.AttendanceData.attendanceExpirationDate, this.props.studentListType, filters, spinnerId, 'get'));
    }

    public sort = (sortKey: string, orderBy: string) => {
        this.props.filters.orderBy = sortKey + '_' + orderBy;
        this.getAttendanceStudentList(1, this.props.filters.orderBy, 'getAttendanceStudentsList');
    };

    public render() {
        const { results, filters } = this.props;
        const loadingSpaces = 64;
        return (
            <>
                <Loading spinnerId={'getAttendanceStudentsList'} width={'100%'}>
                    <div style={{ backgroundColor: '#eeede9' }}>
                        <ContentLoader
                            speed={2}
                            backgroundColor="#f3f3f3"
                            foregroundColor="#ecebeb"
                            viewBox="0 0 700 400"
                            style={{ width: '100%' }}
                        >
                            <circle cx="36" cy="64" r="20" />
                            <rect x="66" y="60" rx="5" ry="5" width="600" height="12" />
                            <circle cx="36" cy={loadingSpaces + 60} r="20" />
                            <rect x="66" y={loadingSpaces + 56} rx="5" ry="5" width="600" height="12" />
                            <circle cx="36" cy={loadingSpaces + 120} r="20" />
                            <rect x="66" y={loadingSpaces + 116} rx="5" ry="5" width="600" height="12" />
                            <circle cx="36" cy={loadingSpaces + 180} r="20" />
                            <rect x="66" y={loadingSpaces + 176} rx="5" ry="5" width="600" height="12" />
                            <circle cx="36" cy={loadingSpaces + 240} r="20" />
                            <rect x="66" y={loadingSpaces + 236} rx="5" ry="5" width="600" height="12" />
                        </ContentLoader>
                    </div>
                </Loading>
                <div id='getAttendanceStudentsList_Content' style={{ width: "-webkit-fill-available" }}>
                    <Table className="table-user-list table-ellipsis table-mobile" striped={true} hover={true} borderless={true}>
                        <thead>
                            <tr style={{ backgroundColor: '#eaeaea' }}>
                                <th scope="col" className="text-center">
                                    {T.t('r_profile_photo')}
                                </th>
                                <SortedColumn
                                    datacell="firstName"
                                    className=" d-lg-table-cell d-xl-table-cell text-center"
                                    title={T.t('r_firstname')}
                                    sortkey="firstName"
                                    sortedcolumn={this.state.filters.orderBy}
                                    sort={this.sort}
                                />
                                <SortedColumn
                                    datacell="lastName"
                                    className=" d-lg-table-cell d-xl-table-cell text-center"
                                    title={T.t('r_lastname')}
                                    sortkey="lastName"
                                    sortedcolumn={this.state.filters.orderBy}
                                    sort={this.sort}
                                />
                                <SortedColumn
                                    datacell="userName"
                                    className=" d-lg-table-cell d-xl-table-cell text-center"
                                    title={T.t('r_username')}
                                    sortkey="userName"
                                    sortedcolumn={this.state.filters.orderBy}
                                    sort={this.sort}
                                />
                                <SortedColumn
                                    datacell="lastProcessDate"
                                    className=" d-lg-table-cell d-xl-table-cell text-center"
                                    title={T.t('r_attendance_join_date')}
                                    sortkey="LastLoginDate"
                                    sortedcolumn={this.state.filters.orderBy}
                                    sort={this.sort}
                                />
                                <th scope="col" style={{minWidth:'175px'}} className="text-center">
                                    {T.t('r_gen_process')}
                                </th>
                                <th scope="col" className="text-center">
                                    {T.t('r_process_status')}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {results.map((item: IAttendanceUserData) => {
                                return (
                                    <tr key={'student-' + item.userName} data-title={item.firstName} style={{ cursor: 'initial' }}>
                                        <td data-label="Profil Resmi" className="text-center" style={{justifyItems:'center', alignContent:'center'}}>
                                            <SecureImage
                                                imageUrl={item.avatarPath ?? ''}
                                                //style={{ width: "auto" }}
                                                class={'media align-items-center mr-2'}
                                            />
                                        </td>
                                        <td data-label={T.t('r_firstname')} className="text-center">
                                            {item.firstName}
                                        </td>
                                        <td data-label={T.t('r_lastname')} className="text-center">
                                            {item.lastName}
                                        </td>
                                        <td data-label={T.t('r_username')} className="text-center">
                                            {item.userName}
                                        </td>
                                        <td data-label={T.t('r_last_process_date')} className="text-center">
                                            {moment(item?.lastLoginDate).format('DD.MM.YYYY HH:mm')}
                                        </td>
                                        <td data-label={T.t('r_process_status')} className="text-center">
                                            {item.status == EQrPollingStatusType.Joined
                                                ?
                                                <Button
                                                    button_type='danger'
                                                    text={T.t('r_take_out_polling')}
                                                    size={'small'}
                                                    iconPosition='left'
                                                    materialicon='close'
                                                    onClick={() => this.handleRemoveAttendanceUser(item)}
                                                />
                                                :
                                                <Button
                                                    button_type='primary'
                                                    text={T.t('r_add_polling')}
                                                    size={'small'}
                                                    iconPosition='left'
                                                    materialicon='add'
                                                    onClick={() => this.addStudenToAttendance(item)}
                                                />
                                            }
                                        </td>
                                        <td data-label={T.t('r_process_status')} className="text-center">
                                            {item.status == EQrPollingStatusType.Joined
                                                ? <i className="material-icons mr-2 icon-rtl" style={{ color: 'green' }}>check_circle</i>
                                                : <i className="material-icons mr-2" style={{ color: 'red' }}>cancel</i>
                                            }
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>

                    </Table>

                    {(results && results.length > 0) && (
                        <div className="row-options justify-content-end">
                            <div
                                className="page-sorting d-flex align-items-center justify-content-center"
                                style={{ marginTop: '5px' }}
                            />
                            <Paginate filters={this.props.filters} onPageChange={this.onPageChange} />
                        </div>
                    )}
                </div>
            </>
        );
    }
}


const mapStateToProps = (state: IAppState, ownProps: IStudentListProps): IStudentListProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IStudentListProps = Object.assign({}, ownProps, {
        coursePageClassId: state.coursePage.coursePageClassId,
        AttendanceData: state.qrPolling.AttendanceData,
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    return false;
};

const CStudentList = connect(
    mapStateToProps,
    dispatchProps,
    null,
    { areStatesEqual }
)(StudentList);


export default CStudentList